import React from 'react';
import { CircleAlertIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-196" data-mp="30xq2l5bk64qk">
      <div className="mx-auto max-w-4xl" data-id="element-197" data-mp="2w5pzj406yvpr">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-198" data-mp="2w4nbd3u977dj">
          <span aria-hidden="true" data-id="element-199" data-mp="2m8bvk3vgfzec">✧ </span>Erkennst du dich in diesen Situationen wieder?
        </h2>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-200" data-mp="2i6ynro8sxm4s">
          {recognizeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-white px-5 py-5" data-id="element-201" data-mp="2d7dofcppzbrj">
              <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-202" data-mp="288iyzrx8yoyg" />
              <p className="text-sm font-medium leading-relaxed text-ink/80" data-id="element-203" data-mp="bg928w6k33el">{item}</p>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-204" data-mp="6gwdu701do9w">
          Und du verdienst so viel mehr als das.
        </p>
      </div>
    </section>;
}